import React from "react";

// Ehrliche Ladeanzeige: beschreibt Arbeit, verspricht keine Dauer, behauptet keine Schritte.
export const ProgressHint = () => (
  <div className="mt-4 flex items-center gap-3" role="status" aria-live="polite" data-testid="progress-hint">
    <span className="relative flex h-2.5 w-2.5" aria-hidden="true">
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#F3651D] opacity-60" />
      <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-[#F3651D]" />
    </span>
    <p className="text-sm text-slate-600" data-testid="progress-hint-text">Deine Einschätzung entsteht gerade.</p>
  </div>
);

export default ProgressHint;
